// extracted by mini-css-extract-plugin
export default {"with-dash":"wEULfX","withDash":"wEULfX","semi-bold":"gnzU0I","semiBold":"gnzU0I"};